import React from "react";
import Closed from "../component/app/closed";

class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      container: "bg-white w-full transition-all duration-500 transform ",
      all: [
        {
          name: "System",
          text: "Display, sound, notifications, power",
          icon: "fas fa-laptop text-xl"
        },
        {
          name: "Devices",
          text: "Bluetooth, printers, mouse",
          icon: "fas fa-headphones-alt text-xl"
        },
        {
          name: "Phone",
          text: "Link your android, Iphone",
          icon: "fas fa-mobile-alt text-xl"
        },
        {
          name: "Network & Internet",
          text: "WI-FI, airplane mode, VPN",
          icon: "fas fa-wifi text-xl"
        },
        {
          name: "Personalization",
          text: "Background, lockscreens, color",
          icon: "fas fa-edit text-xl"
        },
        {
          name: "Apps",
          text: "Uninstall, defaults, optional feature",
          icon: "fas fa-rocket text-xl"
        },
        {
          name: "Accounts",
          text: "Your accouns, email, sync, work, other people",
          icon: "fas fa-user text-xl"
        },
        {
          name: "Time & Languange",
          text: "Speech, region, date",
          icon: "fas fa-clock text-xl"
        },
        {
          name: "Gaming",
          text: "Game bar, DVR, broadcasting, game mode",
          icon: "fas fa-gamepad text-xl"
        },
        {
          name: "Ease of Access",
          text: "Narrator, magnifer, hight contrast",
          icon: "fas fa-hourglass-start text-xl"
        },
        {
          name: "Cortana",
          text: "Cortana languange, permissions, notifications",
          icon: "far fa-circle text-xl"
        },
        {
          name: "Search",
          text: "Languange, permissions, history",
          icon: "fas fa-search text-xl"
        },
        {
          name: "Privacy",
          text: "Location, camera",
          icon: "fas fa-lock text-xl"
        },
        {
          name: "Update & Security",
          text: "Windows update, recovery, backup",
          icon: "fas fa-sync-alt text-xl"
        }
      ]
    };
  }
  render() {
    const props = this.props;
    const state = this.state;
    return (
      <div
        className={
          props.open
            ? state.container + "scale-100"
            : state.container + "scale-0 hidden"
        }
      >
        <Closed theme="dark" name="Setting" />
        <div className="bg-black text-white h-92vh overflow-auto pb-20 p-4">
          <form className="flex flex-wrap text-center justify-center">
            <h5 className="w-full text-3xl py-6">Windows Settings</h5>
            <input
              type="text"
              placeholder="Find a setting"
              className="p-1 w-full sm:w-2/5 focus:outline-none text-black"
            />
          </form>
          <div className="grid grid-flow-row grid-cols-2 sm:grid-cols-3  md:grid-cols-5 gap-2 mt-2">
            {state.all.map((d, i) => (
              <div
                key={i}
                className="border text-center cursor-pointer flex flex-wrap border-gray-900 w-full p-2 justify-center"
              >
                <div className="">
                  <i className={d.icon}></i>
                  <h5 className="w-full">{d.name}</h5>
                  <p className="w-full text-xs font-light">{d.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Setting;
